import { Alert } from '@cmsgov/design-system'
import { useTranslation } from 'react-i18next'

type EasyPayServerErrorAlertProps = {
  className?: string
}
export function EasyPayServerErrorAlert ({
  className
}: EasyPayServerErrorAlertProps) {
  const { t } = useTranslation('easyPayCommon', {
    keyPrefix: 'serverErrorAlert'
  })

  return (
    <Alert variation="error" heading={t('heading')} className={className}>
      {t('content')}
    </Alert>
  )
}
export default EasyPayServerErrorAlert
